module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_photowedding_03@2x-74674798827134310ee28b8399d1a87a.webp";